import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Button, Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../../app/common/modals/modalReducer";
import { ACCOUNT_SIGN_IN_ROUTE } from "../../../app/api/routeConstants";
import { useHistory } from "react-router-dom";
import {
  SIGN_UP_EMPLOYER_MODAL,
  SIGN_UP_JOB_SEEKER_MODAL,
} from "../../../app/common/modals/ModalManager";
import Divider from "../../../app/common/components/Divider";

export default function SignUpModal() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { responsive } = useSelector((state) => state.app);

  function handleSignIn() {
    dispatch(closeModal());
    history.push(ACCOUNT_SIGN_IN_ROUTE);
  }

  return (
    <ModalWrapper
      style={{ minHeight: 380, width: !responsive.isMobile ? 420 : "90%" }}
      modalClassName={"modal-ux-wrapper"}
      contentClassName={"sign-up-modal-content"}
      showDuration={350}
    >
      <Grid
        stackable
        className={
          !responsive.isMobile
            ? "sign-up-container"
            : "sign-up-container-mobile"
        }
      >
        <Grid.Row>
          <Grid.Column>
            <h2>Create your account</h2>
            <div className="sign-in-page-account-sign-up">
              <span className="main-colour">Already have an account? </span>
              <span className="text-link" onClick={handleSignIn}>
                Sign in
              </span>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div className="body-blue-text">
              What type of account do you want to create?
            </div>
            <Button
              className={"overwrite-button teal-inverse-button-long"}
              content={"Job Seeker account"}
              style={{ marginTop: 30 }}
              onClick={() =>
                dispatch(openModal({ modalType: SIGN_UP_JOB_SEEKER_MODAL }))
              }
            />
            <Divider text={"or"} margin={"7px 0"} />
            <Button
              className={"overwrite-button teal-inverse-button-long"}
              content={"Employer account"}
              onClick={() =>
                dispatch(openModal({ modalType: SIGN_UP_EMPLOYER_MODAL }))
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <div className="sign-up-strapline-container">
        <div
          className={
            !responsive.isMobile
              ? "sign-up-strapline-text"
              : "sign-up-strapline-text-mobile"
          }
        >
          <span>hello new job, </span>
          <span>hello new hire</span>
          <span className="accent-colour">.</span>
        </div>
      </div>
    </ModalWrapper>
  );
}
